export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#FF3838" />
    <path d="M36 8 16 36h14l-4 20 22-30H34l4-18z" fill="#0A0B0E" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="font-display text-[15px] font-bold tracking-tight">
      Urgent<span className="text-[#FF3838]">Sell</span>Buy
    </span>
  </span>
);
